export default __webpack_public_path__ + "static/media/accessRequest.cac1099f.svg";